import { ActionHandler } from "..";
import { getActiveUser } from "@noom/hive-auth";
import { queryClient } from "@utils/fetch";
import { getOrAssignExperiment } from "@utils/api/experimentAssignment";

export const MED_TRIAL_EXTENSION_EXPERIMENT_NAME = "sx1467";

export const MED_TRIAL_EXTENSION_QUERY_KEY = [
  "experiment",
  MED_TRIAL_EXTENSION_EXPERIMENT_NAME,
];

function queryFn() {
  const activeUser = getActiveUser();
  if (!activeUser?.accessCode) return Promise.resolve(null);
  return getOrAssignExperiment(
    activeUser.accessCode,
    MED_TRIAL_EXTENSION_EXPERIMENT_NAME
  );
}

/**
 * Kicks off the experiment assignment without blocking page navigation.
 * Uses react-query's built-in dedup — a second call while the first is
 * in-flight reuses the same promise rather than issuing a duplicate request.
 */
export const assignMedTrialExtensionExperiment: ActionHandler = () => {
  queryClient.prefetchQuery(MED_TRIAL_EXTENSION_QUERY_KEY, queryFn);
};

/**
 * Awaits the in-flight experiment assignment started by
 * ASSIGN_MED_TRIAL_EXTENSION_EXPERIMENT. If it already resolved,
 * returns immediately from the cache.
 */
export const waitForMedTrialExtensionExperiment: ActionHandler = async () => {
  await queryClient.fetchQuery(MED_TRIAL_EXTENSION_QUERY_KEY, queryFn);
};
